import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enableSSO, EnableSSORequest } from '../../api/sso';

interface EnableSSSOMutationContext {
  organizationId: number;
}

export function useEnableSSSOMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      organizationId,
      data,
    }: {
      organizationId: number;
      data: EnableSSORequest;
    }) => enableSSO(organizationId, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['sso-status', variables.organizationId],
      });
    },
  });
}
